var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 665,
    height: 731,
    viewBox: "0 0 665 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 665,
    height: 731
  }, /*#__PURE__*/React.createElement("rect", {
    width: 665,
    height: 731,
    fill: "#6020D4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529 369.684L215.316 913L-328 599.316L-14.3162 55.9998L529 369.684ZM372.017 411.747L27.7473 212.983L-171.017 557.252L173.253 756.017L372.017 411.747Z",
    fill: "#6F39D4",
    stroke: "#6F39D4",
    strokeWidth: 45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionPatternLeft);
export default __webpack_public_path__ + "static/media/SectionPatternLeft.3f9b58a10e0965cf596b8d6529f4cc37.svg";
export { ForwardRef as ReactComponent };